function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconExpandFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.648 20.707l-6.233 6.234h5.05v2H3v-8.465h2v5.05l6.234-6.232 1.414 1.413zm14.293 4.82v-5.05h2v8.464h-8.466v-2h5.052l-6.233-6.233 1.415-1.414 6.232 6.233zM11.465 5H6.414l6.235 6.234-1.414 1.414L5 6.415v5.05H3V3h8.465v2zm17.476-2v8.465h-2v-5.05l-6.233 6.233-1.414-1.414L25.527 5h-5.052V3h8.466z",
    fill: props.color
  }));
}

export default SvgIconExpandFilled;